export const RESIDENT_STATUS_OPTIONS = [
    { value: 'specified_skills', label: '特定技能' },
    { value: 'skilled_labor', label: '技術・人文知識・国際業務' },
    { value: 'permanent_resident', label: '永住' },
    { value: 'long_term_resident', label: '定住' },
    { value: 'spouse_of_permanent_resident', label: '永住者の配偶者等' },
    { value: 'spouse_of_japanese_national', label: '日本人の配偶者等' },
    { value: 'other', label: 'その他' },
] as const
